import React from 'react';
import { cn } from "@/lib/utils";
import ComboAnimation from './ComboAnimation';
import AnimatedCharacters from './AnimatedCharacters';

interface AnimatedChar {
  char: string;
  id: number;
  direction: 'left' | 'right';
  x: number;
  y: number;
}

interface ComboAnimationLayerProps {
  combo: number;
  cursorPosition: { x: number; y: number };
  animatingChars: AnimatedChar[];
}

const ComboAnimationLayer = ({ 
  combo, 
  cursorPosition, 
  animatingChars 
}: ComboAnimationLayerProps) => {
  return (
    <>
      <ComboAnimation 
        combo={combo}
        x={cursorPosition.x}
        y={cursorPosition.y}
      />

      <AnimatedCharacters 
        animatingChars={animatingChars}
        combo={combo}
      />
    </>
  );
};

export default ComboAnimationLayer;